import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { adminDashboard } from "../../../actions/questions";
import Loader from "../loader";
import {
  dashboardusers,
  dashboardTransactions,
  loadUser,
} from "../../../actions/auth";
import { Chart } from "react-google-charts";
const AdminDashboardContent = ({ auth: { user, loading } }) => {
  const [dashboardUsersData, setDashboardUsersData] = useState("");
  const [dashboardTransactionsData, setDashboardTransactionsData] =
    useState("");
  const [yearTrue, setYearTrue] = useState(false);
  const [adminLastUpdated, setAdminLastUpdated] = useState(new Date());
  const [lastTrans, setLastTrans] = useState(new Date());
  const [lastUser, setLastUser] = useState(new Date());
  const [chartData, setChartData] = useState([,]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && !loading) {
      setAdminLastUpdated(user.updated_at ? user.updated_at : user.created_at);
    }
    //transactions data(Earning & activties)
    dispatch(dashboardTransactions())
      .then((promiseVal) => {
        if (promiseVal.success) {
        
          setLastTrans(promiseVal.data[0].latestTransaction[0].billing_date);
          let vals = [["x", "Transactions"]];
          promiseVal.data[0].transactionDashboard.map((v) => {
            v.year ? setYearTrue(true) : setYearTrue(false);
            vals.push([v.year ? v.year : v.month, v.count]);
          });
          setChartData(vals);
          setDashboardTransactionsData(promiseVal.data[0]);
        }
      })
      .catch((error) => console.log(error));

    //users data (users count & activties)
    dispatch(dashboardusers())
      .then((promiseValue) => {
        if (promiseValue.success) {
          setDashboardUsersData(promiseValue.data);
          setLastUser(promiseValue.data.latestUser);
        }
      })
      .catch((error) => console.log(error));
  }, []);
  // console.log(dashboardUsersData);
  return (
   <>
      {/* Page Heading */}
      <div className="row">
        {/* Earnings (Monthly) Card Example */}
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Earnings (Monthly)
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">                    
                    {dashboardTransactionsData.monthlyTransactions ? (
                      <span>
                        $
                        {parseFloat(
                          dashboardTransactionsData.monthlyTransactions
                        ).toFixed(2)}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Earnings (Monthly) Card Example */}
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Earnings (Annual)
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {dashboardTransactionsData.annualyTransactions ? (
                      <span>
                        $
                        {parseFloat(
                          dashboardTransactionsData.annualyTransactions
                        ).toFixed(2)}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Earnings (Monthly) Card Example */}
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-info shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                    Active Users
                  </div>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                        {dashboardUsersData.activeusers}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-user fa-2x text-gray-300" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pending Requests Card Example */}
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-warning shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                    Total Users
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {dashboardUsersData.allUsers}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-user fa-2x text-gray-300" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Content Row */}
      <div className="row">
        {/* Content Column */}
        <div className="col-lg-8 mb-4">
          {/* Project Card Example */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Transactions
              </h6>
            </div>
            <div className="mb-4">
              <Chart
                width={"100%"}
                height={"205px"}
                chartType="LineChart"
                loader={<Loader />}
                data={chartData}
                options={{
                  hAxis: {
                    title: yearTrue ? "Years" : "Months",  
                  },
                  vAxis: {
                    title: "Transactions",
                  },
                }}
                rootProps={{ "data-testid": "1" }}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-4 mb-4">
          {/* Illustrations */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Activities</h6>
            </div>
            <div className="card-body">
              <h4 className="small font-weight-bold" style={{ paddingTop: 15 }}>
                Profile updated on{" "}
                <span className="float-right text-primary">
                  {new Date(adminLastUpdated).toDateString()}
                </span>
              </h4>
              <hr />

              <h4 className="small font-weight-bold" style={{ paddingTop: 15 }}>
                Last transaction on
                <span className="float-right text-success">
                  {new Date(lastTrans).toDateString()}
                </span>
              </h4>
              <hr />
              <h4 className="small font-weight-bold" style={{ paddingTop: 15 }}>
                Last user registered on
                <span className="float-right text-info">
                  {new Date(lastUser).toDateString()}
                </span>
              </h4>
              <hr />
            </div>
          </div>
        </div>
      </div>
      </>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  alert: state.alert,
});

export default connect(mapStateToProps, { adminDashboard })(
  AdminDashboardContent
);
